export const seonStreamLabel = 'return-flow'
export const seonStreamSessionTimeoutMs = 30 * 60 * 1000
export const seonStreamStorageKey = 'x_stream'
